import * as _ from 'lodash';

export const mimetypes = [
  'image/png',
  'image/tiff',
  'image/x-tiff',
  'image/x-tiff',
  'image/jpeg',
  'image/pjpeg',
  'image/gif',
  'image/bmp',
  'image/svg+xml',
  'image/x-windows-bmp',
  'application/pdf',
  'application/postscript',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/excel',
  'application/vnd.ms-excel',
  'application/x-excel',
  'application/x-msexcel',
  'text/plain',
  'video/x-flv',
  'video/x-f4v',
  'video/x-msvideo',
  'video/webm',
  'video/ogg',
  'video/mp4',
  'video/x-matroska',
  'audio/aiff',
  'audio/x-aiff',
  'audio/wav',
  'audio/x-ms-wma',
  'audio/x-ms-wax',
  'audio/ogg',
  'audio/ac3',
  'audio/midi',
  'audio/x-midi',
  'audio/mpeg',
  'audio/aac',
];

export const mimetypesAsString = mimetypes.join(',');
